
export const eventTypes = {
    categoryIds: {
        COLLISION: 1,
        THEFT: 2,
        VIOLATION: 3,
    }
};
